const tracerExist = () => window.sumoLogicOpenTelemetryRum?.tracer;

const startSpan = (spanName, attributes) =>
  tracerExist() &&
  window.sumoLogicOpenTelemetryRum.tracer.startSpan(spanName, {
    attributes: {
      ...attributes,
    },
  });

const endSpan = (span, attributes) => {
  if (span && attributes) {
    span.setAttributes(attributes);
  }
  span?.end();
};

const setSpanStatus = (span, status) => {
  span?.setStatus(status);
};

export { startSpan, endSpan, tracerExist, setSpanStatus };
